import React from "react";
var __jsx = React.createElement;
import useIsMobile from "@hooks/useIsMobile";
var PictureResponsiveImage = function PictureResponsiveImage(props) {
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("picture", null, props === null || props === void 0 ? void 0 : props.sources.map(function (source, index) {
    return /*#__PURE__*/React.createElement("source", {
      key: index,
      srcSet: source.image,
      media: source.media
    });
  }), /*#__PURE__*/React.createElement("img", {
    src: props === null || props === void 0 ? void 0 : props.defaultImage,
    width: !isMobile ? "1330px" : "337px",
    height: !isMobile ? "155px" : "87px",
    alt: props === null || props === void 0 ? void 0 : props.alt
  })));
};
export default PictureResponsiveImage;